import html2pdf from 'html2pdf.js';
import {useState,useEffect,useRef} from 'react'; 
import { Link } from 'react-router';
import { Toast } from "primereact/toast";
import {Tablescom} from '../../components/tablescomp';
import { Tag } from 'primereact/tag';
import  Bredcrum  from '../../components/bredcrum';
import {Titlebar,Searchbox,Shipmentstatus} from  '../../components/fieldsComp';

import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import {productservices} from '../../services/productServices';
import {purchaseorderservices} from '../../services/purchaseorderService';
import { Dialog } from 'primereact/dialog';
import '../../assets/recipttemplate.css';
import { FaShippingFast } from 'react-icons/fa';
import {exportToExcel} from '../../helpers/exporttoexcel';
import {stringtodate} from '../../helpers/dateconverter';

import { TabMenu } from 'primereact/tabmenu';
import { MdLoop } from "react-icons/md";
import { Calendar } from 'primereact/calendar';
import { useFormikContext,useFormik,Field,Formik,Form,FieldArray } from 'formik';


const Purchaseorderreports = () => {
  const navigate = useNavigate(); 
  const [results,setResults] = useState([]);
  const [userloaded,setUserLoaded] = useState(true);
  const [visible,setVisible] = useState(false);
  const [quickbookconnected,setQuickbookconnection] = useState(false);
  const [purchsedialog,setPurchasedialog] = useState(false);
  const [purchseordersdata,setPurchaseorderdata] = useState({});
  const [status,setStatus] = useState('');
  const [quickFilterText, setQuickFilterText] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);
  const [filter, setfilter] = useState({ 'fromdate': '', 'todate': '' });
  const pdfRef = useRef();
  const toast = useRef();
  const [colDefs, setColDefs] = useState([
      { headerName: "SR NO",field: "id", width: 100,   cellRenderer: (params) => {
        return params.node.rowIndex + 1; // +1 to start from 1 instead of 0
      }},
      { headerName: "Po Number",field: "ponumber" },
      { headerName: "Po Date",field: "stringpodate"},
      { headerName: "Expected Delivery date",field: "expecteddldate"},
      { headerName: "Ship Ref No",field: "shipment_reference"},
      { headerName: "Freight Cost", field : 'freight_cost'},
      { headerName: "",field: "symbol",width:40},
      { headerName: "Subtotal",field: "subcost"},
      { headerName: "TotalCost",field: "totalcost"},
      
      { headerName: "Status",field: "status",  editable: true,
  cellEditor: 'agSelectCellEditor',
  cellEditorParams: {
    values: ["pending", "dispatched", "partially_received", "fully_received"]
  },


  
  cellRenderer: (params) => {
          return (<>
               <Shipmentstatus status={params.getValue()}/> 
               {/* <Tag severity='danger' value={params.data.status}></Tag> */}
          </>);  
      } },  
    ]);

    const items = [
    {
      label: 'All Orders',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('all'),
      // template: (item) => itemRenderer(item, 0)
    },
    {
      label: 'Open',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('open'),
      //  template: (item) => itemRenderer(item, 1)
    },
    {
      label: 'Dispatched',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('dispatched'),
      //  template: (item) => itemRenderer(item, 2)
    },
    {
      label: 'Partially Received',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('partially_received'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Fully Received',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('fully_received'),
      //  template: (item) => itemRenderer(item, 3)
    },
    {
      label: 'Closed',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('closed'),
      //  template: (item) => itemRenderer(item, 3)
    },

    {
      label: 'Archived',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('archive'),
      //  template: (item) => itemRenderer(item, 3)
    }
  ];


  function handleStockFilter(status){
     getpurchaseOrder(status); 
  } 


    useEffect(() =>{
      getpurchaseOrder('all');
      checkconnection();
    },[]); 


    function getpurchaseOrder(status){
        setUserLoaded(true);
        purchaseorderservices.getpurchaseOrderreport('all',{status:status,fromdate:filter.fromdate,todate:filter.todate}).then((response)=>{
             if(response.status == 200){
                 setResults(response.data.data);  
                 setUserLoaded(false);
             }else{
                 setResults([]);
                 setUserLoaded(false);
             } 
        }).catch((error)=>{
             setResults([]);
             setUserLoaded(false);
        });
    }

    useEffect(()=>{
        getpurchaseOrder('all');      
    },[filter])

    const getRowClass = params => {
    if (params.data.status === 'dispatched') {
      return 'dispatched';
    } else if (params.data.status === 'partially_received') {
      return 'partially_received';
    } else if (params.data.status === 'fully_received') {
      return 'fully_received';
    }
    return '';
  };

  const handleExport = () =>{
      exportToExcel({data:results,filename:'Purchase Order'});
  }


  const checkconnection = () =>{
      purchaseorderservices.checkconnection().then((response)=>{
           if(response.status == 200){
               console.log(response.data.data);
               setQuickbookconnection(true);
           }else{
               setQuickbookconnection(false);
           }
      }).catch((error)=>{
          console.log(error);
          setQuickbookconnection(false);
      });
  }

  

  const moredetail = () =>{
      let maindata = [];
      let items = [];
       maindata = (<tr>
            <td>{purchseordersdata.ponumber}</td>
            <td>{purchseordersdata.shipment_reference}</td>
            <td> <Shipmentstatus status={purchseordersdata.shipment_status}/></td>
            <td>{purchseordersdata.shopname}</td>
        </tr>)
      purchseordersdata?.items?.forEach((value,index) => {
         items.push(
             <tr>
                <td>{value.component}</td>
                <td>{value.quantity} <span className='text-success'>({value.unit})</span></td>
                <td>{value.currency_symbol} &nbsp;{value.unitprice}</td>
                <td>{value.currency_symbol} &nbsp;{value.totalcost}</td>
            </tr>  
        )
      });
      let obj = {
         'maindata':maindata,
         'items':items
      };

      return obj;
  }
  

  return (
    <>
          {/* <Bredcrum title={'Purchase Order Report'} divider={false}/> */}
          <Toast ref={toast}/>
          <div class="row">
                  <Dialog visible={purchsedialog} position='top' modal style={{ width: '80rem' }} onHide={() => {if (!purchsedialog) return; setPurchasedialog(false); }}>
                  </Dialog>

                  <Dialog visible={visible} position='top' modal style={{ width: '80rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                      <div class="container">
                        <table className='table table-bordered'>
                          <tbody>
                            <tr>
                              <th colSpan={4}><h3 className='text-success'>Purchase Order Detail : </h3></th>
                            </tr>
                            <tr>
                              <th>Po Number</th>
                              <th>Shipment Reference</th>
                              <th>Shipment Status</th>
                              <th>Shopname</th>
                            </tr>
                                {moredetail().maindata}
                               <tr>
                              <th colSpan={4}><h3 className='text-success'>Item Details : </h3></th>
                               
                              </tr>  
                               <tr>
                                <th>Component</th>
                                <th>Quantity</th>
                                <th>Unit price</th>
                                <th>Total cost</th>
                              </tr>
                              {moredetail().items}
                           
                          </tbody>
                        </table>
                      </div>
                  </Dialog>
             {/* <Titlebar text={'Purchase Report'}/> */}
              <div className="col-md-12 mt-3">
                    <div className='row'>
                      <div className='col-md-9'>
                            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
                      </div>
                      <div className='col-md-3'>
                          <div> 
                            <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                              <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                            </div>
                      </div>
                    </div> 
                    
                    {/* <Formik
                       initialValues={
                             {
                               selectedMonth:'06/2025'
                             }
                        }
                        enableReinitialize={true}
                        onSubmit={async (values) => {
                            // handleSave(values);
                            console.log(values);
                            console.log("values");
                            
                        }}
                    >
                        {({ values, setFieldValue }) => (
                          <Form>  
                              <div>
                                  <label className='d-block pb-2'><b>Select Month</b></label>  
                                  <Field
                                      type="month"
                                      name="selectedMonth"
                                      className="form-control w-25"  // 'w-10' is too small; adjust as needed
                                      onChange={(e) => {
                                        // Formik change handler
                                        setFieldValue('selectedMonth', e.target.value);
                                        monthfilter(e.target.value); // custom function
                                      }}
                                    />
                                  
                              </div>
                          </Form>
                        )}
                  </Formik> */}
                 
                  
                  <div className='card'>
                    <div className='card-body card-body-style'>
                        <Formik
                            initialValues={{}}
                            enableReinitialize={true}
                            onSubmit={async (values) => {
                                setfilter({ fromdate: values.fromdate, todate: values.todate });
                            }}
                            >
                            <Form>
                                <div className='flex-box pb-3'>
                                <div className='flex-box flex-column date-box-style pb-2'>
                                    <div className='pb-2 primary-text-color'><label>From date</label> </div>
                                    <Field type="date" name="fromdate" placeholder='From date' className='primary-text-color date-input-style' />
                                </div>
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                

                                <div className='flex-box flex-column date-box-style pb-2'>
                                    <div className='pb-2 primary-text-color'><label>To date</label> </div>
                                    <Field type="date" name="todate" placeholder='To date' className='primary-text-color date-input-style' />
                                </div>
                                &nbsp;
                                &nbsp;

                                <div className='date-box'>
                                    <button type='submit' className='btn-success text-white'>Filter</button>
                                </div>
                                </div>
                            </Form>
                            </Formik>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} quickFilterText={quickFilterText} getRowClass={getRowClass}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
  );
};

export default Purchaseorderreports;
